import axios from 'axios'
import moment from 'moment'
import { reset } from 'redux-form'
import { chain, extend, zipObject, sortBy } from 'lodash'

import * as types from '../constants/actionTypes'
import { displayNotification } from './notificationsActions'
import { getAssignedConvSums } from './convSumsActions'
import { setGlobalLoading } from './globalLoadingActions'

export const requestConvAssignment = () => ({
  type: types.RequestConvAssignment,
})

export const receivedConvAssignment = () => ({
  type: types.ReceivedConvAssignment,
})

export const requestConvAssignmentFailure = () => ({
  type: types.RequestConvAssignmentFailure,
})

export const requestCurrentConv = () => ({
  type: types.RequestCurrentConv,
})

export const receivedCurrentConv = (data) => ({
  type: types.ReceivedCurrentConv,
  data,
})

export const groupMessagesByDate = (groups) => ({
  type: types.GroupMessagesByDate,
  groups,
})

export const requestCurrentConvFailure = () => ({
  type: types.RequestCurrentConvFailure,
})

export const destroyCurrentConv = () => ({
  type: types.DestroyCurrentConv,
})

export const updatingCurrentConv = () => ({
  type: types.UpdatingCurrentConv,
})

export const postMessage = () => ({
  type: types.PostMessage,
})

export const postMessageSuccess = () => ({
  type: types.PostMessageSuccess,
})

export const postMessageFailure = () => ({
  type: types.PostMessageFailure,
})

export const addMessageAction = (data) => ({
  type: types.AddNewMessage,
  data,
})

export const addMessage = (data) => {
  const currentDate = moment().startOf('day').format()
  const grouped = {
    date: currentDate,
    messages: [data],
  }

  return (dispatch) => {
    dispatch(addMessageAction(grouped))
  }
}

export const updateMessage = (message) => ({
  type: types.UpdateMessage,
  message,
})

export const putConvAssignment = (id) => {
  return (dispatch) => {
    dispatch(requestConvAssignment())
    return axios
      .put(
        `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/conversations/${id}/assign`
      )
      .then(() => {
        dispatch(receivedConvAssignment())
        dispatch(getAssignedConvSums())
      })
      .catch(() => {
        // TODO: Commented out till we have a way to do client-side error reporting to SumoLogic
        // const errorMessage = error.response && error.response.data ? error.response.data.message : 'Something went wrong';
        dispatch(requestConvAssignmentFailure())
      })
  }
}

export const chunkMessagesByDay = (conversation) => {
  const { messages, resolutions } = conversation
  const catMessages = messages.concat(resolutions)
  const orderdMessages = sortBy(
    catMessages,
    (message) => new Date(message.created_at)
  )

  let groupedMessages = chain(orderdMessages)
    .map((message) => {
      return extend(message, {
        date: moment(message.created_at).startOf('day').format(),
      })
    })
    .groupBy('date')
    .toPairs()
    .map((messages) => {
      return zipObject(['date', 'messages'], messages)
    })
    .value()

  return groupedMessages
}

export const submitMessage = (data) => {
  return (dispatch) => {
    dispatch(postMessage())
    return axios
      .post(
        `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/conversations/${data.id}/messages`,
        {
          content: data.content,
        }
      )
      .then(() => {
        dispatch(postMessageSuccess())
        dispatch(reset('messageForm'))
      })
      .catch((error) => {
        const message = `Your message failed to send: ${error.message}`
        dispatch(postMessageFailure())
        dispatch(displayNotification(message, 'error'))
      })
  }
}

export const toggleReassignConvVisible = () => {
  return {
    type: types.ToggleReassignConvVisible,
  }
}

export const reassignConversation = (convId, adminUserId, adminUserName) => {
  return (dispatch) => {
    return axios
      .put(
        `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/conversations/${convId}/reassign`,
        {
          admin_id: adminUserId,
        }
      )
      .then(() => {
        dispatch({
          type: types.ReassignConversationSuccess,
          convId,
          adminUserId,
          adminUserName,
        })

        return dispatch(getAssignedConvSums())
      })
      .then(() => {
        dispatch(
          displayNotification(
            `Ticket was successfully reassigned to ${adminUserName}`,
            'success',
            3000
          )
        )
      })
      .catch((err) => {
        dispatch(
          displayNotification(`Something went wrong: ${err}`, 'error', 7000)
        )
      })
  }
}

export const getCurrentConv = (id) => {
  return (dispatch) => {
    dispatch(setGlobalLoading(true))
    dispatch(requestCurrentConv())
    return axios
      .get(
        `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/conversations/${id}`
      )
      .then((res) => {
        dispatch(receivedCurrentConv(res.data))
        const chunkedMessages = chunkMessagesByDay(res.data)
        dispatch(groupMessagesByDate(chunkedMessages))
        dispatch(setGlobalLoading(false))
      })
      .catch(() => {
        // TODO: Commented out till we have a way to do client-side error reporting to SumoLogic
        // const errorMessage = error.response && error.response.data ? error.response.data.message : 'Something went wrong';
        dispatch(requestCurrentConvFailure())
        dispatch(setGlobalLoading(false))
      })
  }
}

export const updateCurrentConv = (id) => {
  return (dispatch) => {
    dispatch(updatingCurrentConv())
    dispatch(destroyCurrentConv())
    dispatch(putConvAssignment(id))
    dispatch(getCurrentConv(id))
  }
}
